(function () {
  if (window.__myaoBuyNowLoginDialogV6Initialized) return;
  window.__myaoBuyNowLoginDialogV6Initialized = true;

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function setDialogOpenState(isOpen) {
    document.documentElement.classList.toggle('myao-buy-now-login-dialog-open', isOpen);
    document.body.classList.toggle('myao-buy-now-login-dialog-open', isOpen);
  }

  function getFlowMode(triggerEl) {
    if (!triggerEl) return 'buy-now';
    return triggerEl.getAttribute('data-myao-flow-mode') === 'checkout-only'
      ? 'checkout-only'
      : 'buy-now';
  }

  function readVariantId(formEl) {
    var idEl = formEl ? q('[name="id"]', formEl) : null;
    return idEl ? String(idEl.value || '').trim() : '';
  }

  function readQuantity(formEl) {
    var qtyEl = formEl ? q('[name="quantity"]', formEl) : null;
    var qty = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
    if (!isFinite(qty) || qty < 1) qty = 1;
    return qty;
  }

  function readSellingPlan(formEl) {
    var sellingPlanEl = formEl ? q('[name="selling_plan"]', formEl) : null;
    return sellingPlanEl ? String(sellingPlanEl.value || '').trim() : '';
  }

  function normalizePropertyName(name) {
    return String(name || '')
      .replace(/^properties\[/, '')
      .replace(/\]$/, '');
  }

  function readProperties(formEl) {
    if (!formEl) return {};
    var props = {};

    qa('[name^="properties["]', formEl).forEach(function (el) {
      if (!el || el.disabled || !el.name) return;

      var type = String(el.type || '').toLowerCase();
      var key = normalizePropertyName(el.name);
      if (!key) return;

      if (type === 'file') return;

      if (type === 'checkbox') {
        if (!el.checked) return;
        props[key] = String(el.value || 'はい');
        return;
      }

      if (type === 'radio') {
        if (!el.checked) return;
        props[key] = String(el.value || '');
        return;
      }

      var value = String(el.value || '').trim();
      if (!value) return;
      props[key] = value;
    });

    return props;
  }

  function getFormEl(triggerEl) {
    if (!triggerEl) return null;

    var formId = triggerEl.getAttribute('data-product-form-id');
    if (formId) {
      var byId = document.getElementById(formId);
      if (byId) return byId;
    }

    return (
      (triggerEl.closest && triggerEl.closest('form')) ||
      document.querySelector('form[id^="product-form-"]') ||
      document.querySelector('form[action^="/cart/add"]') ||
      null
    );
  }

  function getDialog(triggerEl) {
    var targetId = triggerEl ? triggerEl.getAttribute('data-myao-buy-now-dialog-target') : '';
    if (targetId) {
      var byId = document.getElementById(targetId);
      if (byId) return byId;
    }
    return q('[data-myao-buy-now-login-dialog]');
  }

  function getCheckoutNaviPath(dialogEl) {
    return (dialogEl && dialogEl.getAttribute('data-checkout-navi-path')) || '/pages/checkout-navi';
  }

  function buildRedirectUrl(dialogEl) {
    var accountsEnabled = dialogEl && dialogEl.getAttribute('data-customer-accounts-enabled') === 'true';
    var isLoggedIn = dialogEl && dialogEl.getAttribute('data-logged-in') === 'true';

    if (!accountsEnabled || isLoggedIn) {
      return '/checkout';
    }

    return '/customer_authentication/login?return_to=' + encodeURIComponent(getCheckoutNaviPath(dialogEl));
  }

  function buildPayload(triggerEl) {
    var formEl = getFormEl(triggerEl);
    var variantId = readVariantId(formEl);
    if (!variantId) return null;

    var payload = {
      id: Number(variantId),
      quantity: readQuantity(formEl),
      properties: readProperties(formEl)
    };

    var sellingPlan = readSellingPlan(formEl);
    if (sellingPlan) {
      payload.selling_plan = sellingPlan;
    }

    return payload;
  }

  function buildFingerprint(payload) {
    if (!payload) return '';
    return [String(payload.id || ''), String(payload.quantity || 1)].join('||');
  }

  function rememberFingerprint(fingerprint) {
    try {
      sessionStorage.setItem('__myao_buy_now_last_submit', JSON.stringify({
        fingerprint: fingerprint,
        at: Date.now()
      }));
    } catch (e) {}
  }

  function isRecentlySubmitted(fingerprint) {
    try {
      var raw = sessionStorage.getItem('__myao_buy_now_last_submit');
      if (!raw) return false;

      var data = JSON.parse(raw);
      if (!data || data.fingerprint !== fingerprint) return false;

      return (Date.now() - Number(data.at || 0)) < 10000;
    } catch (e) {
      return false;
    }
  }

  function fetchCart() {
    return fetch(getRoutesRoot() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(text || 'cart fetch failed');
        });
      }
      return response.json();
    });
  }

  function cartHasSameVariant(cart, payload) {
    if (!cart || !cart.items || !cart.items.length || !payload) return false;

    return cart.items.some(function (item) {
      return String(item.variant_id || item.id || '') === String(payload.id || '');
    });
  }

  function addToCart(payload) {
    return fetch(getRoutesRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [payload]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(text || 'cart add failed');
        });
      }
      return response.json();
    });
  }

  function showScreen(dialogEl) {
    var accountsEnabled = dialogEl.getAttribute('data-customer-accounts-enabled') === 'true';
    var isLoggedIn = dialogEl.getAttribute('data-logged-in') === 'true';
    var screenToShow = (!accountsEnabled || isLoggedIn) ? 'member' : 'guest';

    qa('[data-myao-screen]', dialogEl).forEach(function (screen) {
      var shouldShow = screen.getAttribute('data-myao-screen') === screenToShow;
      screen.hidden = !shouldShow;
      screen.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }

  function setButtonsDisabled(dialogEl, disabled) {
    qa('[data-myao-dialog-next]', dialogEl).forEach(function (btn) {
      btn.disabled = !!disabled;
    });
  }

  function resetSubmitting(dialogEl) {
    if (dialogEl) {
      dialogEl.removeAttribute('data-submitting');
    }
    window.__myaoBuyNowSubmitting = false;
    if (dialogEl) {
      setButtonsDisabled(dialogEl, false);
    }
  }

  function openDialog(dialogEl, state, triggerEl) {
    var mode = (state && state.mode) || 'buy-now';
    var payload = state && state.payload ? state.payload : null;

    dialogEl.setAttribute('data-flow-mode', mode);

    if (payload) {
      dialogEl.setAttribute('data-cart-add-payload', JSON.stringify(payload));
      dialogEl.setAttribute('data-request-fingerprint', buildFingerprint(payload));
    } else {
      dialogEl.removeAttribute('data-cart-add-payload');
      dialogEl.removeAttribute('data-request-fingerprint');
    }

    if (triggerEl) {
      dialogEl.__myaoLastFocused = triggerEl;
    }

    showScreen(dialogEl);
    dialogEl.hidden = false;
    dialogEl.setAttribute('aria-hidden', 'false');
    setDialogOpenState(true);
    resetSubmitting(dialogEl);

    var panel = q('.myao-buy-now-login-dialog__panel', dialogEl);
    if (panel) panel.focus();
  }

  function closeDialog(dialogEl) {
    if (!dialogEl) return;

    dialogEl.hidden = true;
    dialogEl.setAttribute('aria-hidden', 'true');
    dialogEl.removeAttribute('data-cart-add-payload');
    dialogEl.removeAttribute('data-request-fingerprint');
    dialogEl.removeAttribute('data-submitting');
    dialogEl.removeAttribute('data-flow-mode');
    setDialogOpenState(false);
    setButtonsDisabled(dialogEl, false);
    window.__myaoBuyNowSubmitting = false;

    if (dialogEl.__myaoLastFocused && typeof dialogEl.__myaoLastFocused.focus === 'function') {
      dialogEl.__myaoLastFocused.focus();
    }
  }

  function proceed(dialogEl) {
    if (!dialogEl) return;
    if (dialogEl.getAttribute('data-submitting') === 'true') return;
    if (window.__myaoBuyNowSubmitting) return;

    var mode = dialogEl.getAttribute('data-flow-mode') || 'buy-now';
    var redirectUrl = buildRedirectUrl(dialogEl);

    if (mode === 'checkout-only') {
      dialogEl.setAttribute('data-submitting', 'true');
      window.__myaoBuyNowSubmitting = true;
      setButtonsDisabled(dialogEl, true);
      window.location.assign(redirectUrl);
      return;
    }

    var payloadRaw = dialogEl.getAttribute('data-cart-add-payload') || '';
    if (!payloadRaw) return;

    var payload;
    try {
      payload = JSON.parse(payloadRaw);
    } catch (e) {
      return;
    }

    var fingerprint = dialogEl.getAttribute('data-request-fingerprint') || buildFingerprint(payload);

    if (isRecentlySubmitted(fingerprint)) {
      window.location.assign(redirectUrl);
      return;
    }

    dialogEl.setAttribute('data-submitting', 'true');
    window.__myaoBuyNowSubmitting = true;
    setButtonsDisabled(dialogEl, true);

    fetchCart()
      .then(function (cart) {
        if (cartHasSameVariant(cart, payload)) {
          rememberFingerprint(fingerprint);
          window.location.assign(redirectUrl);
          return null;
        }

        return addToCart(payload).then(function () {
          rememberFingerprint(fingerprint);
          window.location.assign(redirectUrl);
          return null;
        });
      })
      .catch(function (error) {
        console.error('[myao-buy-now] cart check/add failed', error);
        resetSubmitting(dialogEl);
        window.alert('購入処理に失敗しました。時間をおいて再度お試しください。');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-myao-buy-now-login-open]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      var dialogEl = getDialog(trigger);
      if (!dialogEl) return;

      var mode = getFlowMode(trigger);

      if (mode === 'checkout-only') {
        openDialog(dialogEl, { mode: 'checkout-only' }, trigger);
        return;
      }

      var payload = buildPayload(trigger);
      if (!payload || !payload.id) {
        window.alert('購入できませんでした。商品オプションを選択してから再度お試しください。');
        return;
      }

      openDialog(dialogEl, { mode: 'buy-now', payload: payload }, trigger);
      return;
    }

    var closeTrigger = event.target.closest && event.target.closest('[data-myao-dialog-close], [data-myao-dialog-back]');
    if (closeTrigger) {
      event.preventDefault();
      var closeDialogEl = closeTrigger.closest('[data-myao-buy-now-login-dialog]');
      closeDialog(closeDialogEl);
      return;
    }

    var nextTrigger = event.target.closest && event.target.closest('[data-myao-dialog-next]');
    if (nextTrigger) {
      event.preventDefault();
      var nextDialogEl = nextTrigger.closest('[data-myao-buy-now-login-dialog]');
      proceed(nextDialogEl);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openDialogEl = qa('[data-myao-buy-now-login-dialog]').find(function (dialog) {
      return !dialog.hidden;
    });

    if (!openDialogEl) return;
    closeDialog(openDialogEl);
  });
})();
